import { render, staticRenderFns } from "./CommonRate.vue?vue&type=template&id=faa6f9bc&scoped=true&"
import script from "./CommonRate.vue?vue&type=script&lang=js&"
export * from "./CommonRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa6f9bc",
  null
  
)

export default component.exports